module.exports = ".dateRangeOptions {\r\n\tclear: both;\r\n}\r\n"